// removeNamedWindow — VQE-Edit edit-action: remove a `WINDOW w AS (…)`
// definition via SR-Edit's `remove-named-window` op. Removing the last
// definition drops the whole WINDOW clause (keyword included) resolver-side.
//
// Task: VQE Polish §4b-ii — named-window card real editing.

import { commitEdit, type CommitEditCtx } from '../commitEdit';

export async function removeNamedWindow(
  index: number,
  ctx: CommitEditCtx,
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(`removeNamedWindow: index must be a non-negative integer (got ${index})`);
  }
  await commitEdit({ op: 'remove-named-window', index }, ctx);
}
